import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CheckEmptyUtil } from '../shared/util/check-empty.util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpUtilService {
  constructor(private httpClient: HttpClient) {}

  async search(query: string, apiEndPoint):Promise<Observable<HttpResponse<Object>>> {
    let api_host = environment.apiUrl;
    return await this.httpClient
      .get(api_host + apiEndPoint, { params: { query: query.toLowerCase() },observe:'response' });
  }

  async invoke(method, postBody, endPoint, currentUserEmail) :Promise<Observable<HttpResponse<Object>>> {
    const url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    if (CheckEmptyUtil.isNotEmpty(currentUserEmail)) {
      requestHeaders.email = currentUserEmail;
    }
    const headers = new HttpHeaders(requestHeaders);
    var body = CheckEmptyUtil.isNotEmptyObject(postBody) ? postBody : null;
    body = JSON.stringify(body);

    return await this.httpClient
        .request(method, url, { body, headers, observe:'response' });
  }

  request<T = any>(method: string, data: any, endPoint: string): Observable<HttpResponse<T>> {
    const url = environment.apiUrl + endPoint;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    const options: {
      headers: HttpHeaders;
      observe: 'response';
      body?: any;
      params?: HttpParams;
    } = {
      headers,
      observe: 'response',
    };

    if (method.toUpperCase() === 'GET') {
      let httpParams = new HttpParams();
      for (const key in data) {
        if (data.hasOwnProperty(key) && data[key] != null) {
          httpParams = httpParams.set(key, data[key]);
        }
      }
      options.params = httpParams;
    } else {
      options.body = data; // 👈 send JSON body
    }

    return this.httpClient.request<T>(method, url, options);
  }

  async invokeQuery(method, params, endPoint):Promise<Observable<HttpResponse<Object>>> {
    let url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const headers = new HttpHeaders(requestHeaders);

    if (params) {
      url = url + '?' + params.key + '=' + params.value;
    }

    
    return this.httpClient
        .request(method, url, { headers, observe:'response' });
  }

  async invokeQueryAnyParams(method: string, params: any[], endPoint: string): Promise<Observable<HttpResponse<any>>> {
    let url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const headers = new HttpHeaders(requestHeaders);

    // Build query string using map and join
    if (params && params.length > 0) {
      const queryString = params.map(param => `${param.key}=${param.value}`).join('&');
      url = `${url}?${queryString}`;
    }

    return this.httpClient
        .request(method, url, { headers, observe: 'response' });
}

  async invokeQueryWithTwoParams(method, params1, params2, endPoint):Promise<Observable<HttpResponse<Object>>> {
    let url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const headers = new HttpHeaders(requestHeaders);

    if (params1 && params2) {
      url =
        url +
        '?' +
        params1.key +
        '=' +
        params1.value +
        '&' +
        params2.key +
        '=' +
        params2.value;
    }

    // const promise = new Promise((resolve, reject) => {
      return await this.httpClient
        .request(method, url, { headers, observe:'response' });

        /*.subscribe(response => {
          return resolve(response);
        }, err => {
          return reject(err);
        });*/
    //}); 
  }

  async invokePathParam(method, params1, params2, endPoint):Promise<Observable<HttpResponse<Object>>> {
    let url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const headers = new HttpHeaders(requestHeaders);

    if (params1 && params2) {
      url = url + '/' + params1.value + '/' + params2.value;
    } else {
      url = url + '/' + params1.value;
    }
 
    return await this.httpClient
        .request(method, url, { headers: headers, observe:'response' });
        /*.subscribe(response => {
          return resolve(response);
        }, err => {
          return reject(err);
        });*/
  }

  async invokeWithFormData(method, body, endpoint):Promise<Observable<HttpResponse<any>>> {
    const url = environment.apiUrl + endpoint;
    const requestHeaders: any = {
      Accept: 'application/json',
    };
    const headers = new HttpHeaders(requestHeaders);

    return await this.httpClient.request(method, url, {body: body, headers: headers, observe:'response'})
  }

  invokeWithFormDataFile(method, body, endpoint):Observable<HttpResponse<any>> {
    const url = environment.apiUrl + endpoint;
    const requestHeaders: any = {
      Accept: 'application/json',
    };
    const headers = new HttpHeaders(requestHeaders);

    return this.httpClient.request(method, url, {body: body, headers: headers, observe:'response'})
  }


  async invokePostWithFormData(method, postBody, endPoint, currentUserEmail):Promise<Observable<HttpResponse<Object>>> {
    const url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      Accept: 'application/json',
    };

    if (CheckEmptyUtil.isNotEmpty(currentUserEmail)) {
      requestHeaders.email = currentUserEmail;
    }
    const headers = new HttpHeaders(requestHeaders);
    const body = postBody;

    //const promise = new Promise((resolve, reject) => {
    return await this.httpClient
        .post(url, postBody, { headers: headers, observe:'response' });
        
        /*.subscribe(response => {
          return resolve(response);
        }, err => {
          return reject(err);
        });*/
    
    //return promise;
  }


  async login(postBody, endPoint, currentUserEmail):Promise<Observable<HttpResponse<Object>>>  {
    const url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      Accept: 'application/json',
    };

    if (CheckEmptyUtil.isNotEmpty(currentUserEmail)) {
      requestHeaders.email = currentUserEmail;
    }
    const body = CheckEmptyUtil.isNotEmptyObject(postBody) ? postBody : null;

    return await this.httpClient
        .post(url, body,{observe:'response'}); 
        /*.subscribe(response => { 
          console.log(response);
          return resolve(response);
        }, err => {
          return reject(err);
        });*/
    
    //return promise;
  }

  invokeGetForSign(endPoint) {
    let url = environment.apiUrl + endPoint;

    const promise = new Promise((resolve, reject) => {
      this.httpClient
        .get(url,{observe:'response'})
        .subscribe((response: any) => {
          return resolve(response);
        }, err => {
          return reject(err);
        });
    });
    return promise;
  }
  
  invokeQueryWithFourParams(method, params1, params2, params3, params4, endPoint) {
    let url = environment.apiUrl + endPoint;
    const requestHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const headers = new HttpHeaders(requestHeaders); 
    
    if (params1 && params2 && params3 && params4) {
      url =
        url +
        '?' +
        params1.key +
        '=' +
        params1.value +
        '&' +
        params2.key +
        '=' +
        params2.value + 
        '&' + 
        params3.key + 
        '=' + 
        params3.value + 
        '&' + 
        params4.key + 
        '=' + 
        params4.value;

    }

    const promise = new Promise((resolve, reject) => {
      this.httpClient
        .request(method, url, { headers, observe:'response' })
        .subscribe(response => {
          return resolve(response);
        }, err => {
          return reject(err);
        });
    });
    return promise;
  }
  
  ObjectsToParams(obj) {
    var p = [];
    for (var key in obj) {
      p.push(key + '=' + encodeURIComponent(obj[key]));
    }
    return p.join('&');
  }
}
